/* Le classi ricorrenti dell'indice /report, sul modello del 19/10/2026
   (uploads/report.html, istruzioni in uploads/ISTRUZIONI-report.md).

   Modulo senza direttiva: lo leggono sia i Server Component (apertura,
   schede, archivio) sia la barra di ricerca, che è client.

   Colori: solo i token della prima pagina, che il modello ripete: carta =
   `bg`, superficie = `surface`, acqua = `petrolio`, inchiostro = `ink`,
   sonda = `sommesso`, filetto = `rule`, mare = `mare`, il segnale rame
   (`seg-rame`) = `segnale`. Lo scuro è quello del disegno, ridichiarato
   in `.dark .oi-report` (globals.css, accanto a `.oi-rullo`).

   Il confine è quello del modello, 900 pixel (`max-width: 900px`): una
   colonna fino a 900, sopra le colonne piene. Le varianti sono scritte
   con `min-[901px]:`, e nessuna classe della stessa proprietà usa anche
   `md:`/`lg:`, così l'ordine di emissione non conta (vedi LEARNINGS,
   «Un breakpoint custom in px… perde la cascata»). */

import { FUOCO_HOME } from "@/components/home/stile";

export const FUOCO_REP = FUOCO_HOME;

/** La riga delle etichette (`.tg`): mono 12, spaziatura 0,06em, sonda. */
export const ETICHETTE = "font-mono text-meta uppercase tracking-dato text-sommesso";

/** Le date (`.dt`): mono 12, sonda, il valore in grassetto inchiostro. */
export const DATE = "font-mono text-meta text-sommesso";

/** Il pannello dei blocchi: filetto inchiostro, rame in cima, superficie. */
export const PANNELLO = "border border-ink border-t-4 border-t-segnale bg-surface";
